import helpers from 'src/helpers'

export default {
  tableDataeVoucher: state => {
    return state.eVoucherList
  },
  getActivationData: state => {
    let data = {
      ibo_member_id: helpers.getValue(state.eVoucherData, 'data.ibo_member_id'),
      invoice_number: helpers.getValue(state.eVoucherData, 'data.invoice_number'),
      eVoucher_number: helpers.getValue(state.eVoucherData, 'data.evoucher_number'),
      request_type: '',
      user_id: helpers.getValue(state.eVoucherData, 'data.sale.downline_member_id'),
      contact: '',
      code: state.evoucherActivationRequestData.data.code,
      evouchers: [],
    }
    return data
  },
  getActivationResponseData: state => {
    return state.evoucherActivationRequestData.data
  },
}
